// Заглушка node:crypto для jkurwa в браузері: їй потрібен лише rng
const rng = (n) => globalThis.crypto.getRandomValues(new Uint8Array(n));
export default { rng, randomBytes: rng };
export { rng, rng as randomBytes };
